import DropDown from './components/Shared/DropDown.vue';
import Modal from './components/Shared/Modal/Modal.vue';
import Pagination from './components/Shared/Pagination/Pagination.vue';
import ChangePasswordModal from './modals/ChangePasswordModal.vue';
import TopNavBar from './components/Layout/TopNavbar.vue';
import Loader from './components/Shared/Loader.vue';
import EditOrderModal from "./modals/EditOrderModal.vue";
import AddUserModal from "./modals/AddUserModal.vue";
import AddCompanyModal from "./modals/AddCompanyModal.vue";
import AddCompanyStuffModal from "./modals/AddCompanyStuffModal.vue";
import AddVehicleModal from "./modals/AddVehicleModal.vue";
import CompleteDayModal from "./modals/CompleteDayModal.vue";
import EditRegionModal from "./modals/EditRegionModal.vue";
import EditAddressModal from "./modals/EditAddressModal.vue";
import AddDispatcherModal from "./modals/AddDispatcherModal.vue";
import ToggleButton from "./modals/ToggleButton.vue";
import EditScheduleVehicleModal from "./modals/EditScheduleVehicleModal.vue";
import AddVersionModal from "./modals/AddVersionModal.vue";
import AddCompanyCupons from "./modals/AddCompanyCupons.vue";
import DeclineVacation from "./modals/DeclineVacationModal.vue";
import EditScheduleShiftModal from "./modals/EditScheduleShiftModal.vue";
import AddCourierFreeDay from "./modals/AddCourierFreeDay.vue";
import OpenAnotherShiftModal from "./modals/OpenAnotherShiftModal.vue";
import ChangeCourierStartShift from "./modals/ChangeCourierStartShift.vue";
import AddVehicleCostModal from "./modals/AddVehicleCostModal.vue";
import ShowCommentSchedule from "./modals/ShowCommentSchedule.vue";
import PrintSchedule from "./modals/PrintSchedule.vue";


/**
 * Register global components here and use them as a plugin in your main Vue instance
 */

const SharedComponents = {
    install (Vue) {
        Vue.component('loader', Loader);
        Vue.component('drop-down', DropDown);
        Vue.component('modal', Modal);
        Vue.component('change-password-modal', ChangePasswordModal);
        Vue.component('edit-order-modal', EditOrderModal);
        Vue.component('edit-region-modal', EditRegionModal);
        Vue.component('edit-schedule-vehicle-modal', EditScheduleVehicleModal);
        Vue.component('edit-schedule-shift-modal', EditScheduleShiftModal);
        Vue.component('edit-address-modal', EditAddressModal);
        Vue.component('decline-vacation', DeclineVacation);
        Vue.component('add-user-modal', AddUserModal);
        Vue.component('add-version-modal', AddVersionModal);
        Vue.component('add-company-cupons-modal', AddCompanyCupons);
        Vue.component('add-dispatcher-modal', AddDispatcherModal);
        Vue.component('open-another-shift-modal', OpenAnotherShiftModal);
        Vue.component('add-free-days-modal', AddCourierFreeDay);
        Vue.component('change-courier-start-time', ChangeCourierStartShift);
        Vue.component('add-company-modal', AddCompanyModal);
        Vue.component('toggle-button', ToggleButton);
        Vue.component('complete-day-modal', CompleteDayModal);
        Vue.component('add-company-stuff-modal', AddCompanyStuffModal);
        Vue.component('print-schedule', PrintSchedule);
        Vue.component('add-vehicle-modal', AddVehicleModal);
        Vue.component('add-vehicle-cost-modal', AddVehicleCostModal);
        Vue.component('show-comment-schedule-modal', ShowCommentSchedule);
        Vue.component('pagination', Pagination);
        Vue.component('topnavbar', TopNavBar);
    }
}

export default SharedComponents



// WEBPACK FOOTER //
// ./src/sharedComponents.js